import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbIconModule, NbDialogModule, NbCardModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { UserAccountSidebarComponent } from './user-account-sidebar.component';
import { LogoutConfirmationDialogComponent } from '../logout-confirmation-dialog/logout-confirmation-dialog.component';
import { WyborKlientaModule } from '../wybor-klienta/wybor-klienta.module';

@NgModule({
  declarations: [
    UserAccountSidebarComponent,
    LogoutConfirmationDialogComponent,
  ],
  exports: [
    UserAccountSidebarComponent,
  ],
  imports: [
    CommonModule,
    NbButtonModule,
    NbCardModule,
    NbIconModule,
    NbDialogModule,
    TranslateModule,
    WyborKlientaModule,
  ],
})
export class UserAccountSidebarModule { }
